const config = {
  namespaced: true,
  state: {
    configurationData: {}
  },
  mutations: {
    setConfigurationData(state, payload) {
      state.configurationData = payload;
    },
    appendConfigurationData(state, config) {
      state.configurationData = { ...state.configurationData, ...config };
    }
  }
};

export default config;
